import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

function ConfirmDialog({ open, title, content, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className="confirm-dialog">
        <DialogTitle className="confirm-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText className="confirm-dialog-message">
            <p className="confirm-dialog-message"> {content}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="confirm-dialog-actions">
          <Button onClick={onClose} className="cancel-button">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="error"
            className="confirm-button"
          >
            Confirm
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmDialog;
